export default {
  path: '/appointment/table-view',
  name: 'appointment.tableView',
  meta: {
    layout: 'vertical'
  },
  component: () => import('@/views/pages/appointmentManagement/TableView.vue'),
}